import React, {useState} from 'react';
import Link from '@mui/material/Link';
import {Button} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {Typography} from '@mui/material';
import DashboardTile from '../../components/Tiles/DashboardTile';

const StudentList = ({data, count}) => {
  const [seeMore, setSeeMore] = useState(false);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const short = 10;
  const page = 20;

  if (!data) {
    return null;
  }

  const sorted = data.sort((a, b) => {
    const aDate = new Date(a.atRiskDate).getTime();
    const bDate = new Date(b.atRiskDate).getTime();
    const val = bDate - aDate;
    return val;
  });

  const toReadable = key => {
    switch (key) {
      case 'total':
        return 'Total';
      case 'cashFlow':
        return 'Negative Cash Flow';
      case 'netWorth':
        return 'Negative Net Worth';
      case 'overdraft':
        return 'Overdraft';
      case 'creditDebt':
        return 'Credit Card Debt';
      case 'creditUtilization':
        return 'High Credit Utilization';
      case 'interest':
        return 'Interest';
      default:
        return key;
    }
  };

  const findCriteria = data => {
    if (!data) {
      return '';
    }
    let reason = '';
    let count = 0;
    Object.keys(data).forEach(key => {
      const criteria = data[key];
      if (criteria.risk) {
        if (count) {
          reason += ', ' + toReadable(key);
        } else {
          reason += toReadable(key);
        }
        count += 1;
      }
    });
    return reason;
  };

  return (
    <DashboardTile header="Students at Risk" bigContent={count}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{fontWeight: 'bold'}}>Unique ID</TableCell>
            <TableCell sx={{fontWeight: 'bold'}}>Begin Date</TableCell>
            <TableCell sx={{fontWeight: 'bold'}}>Criteria</TableCell>
            {/* <TableCell sx={{fontWeight: 'bold'}}>Send help?</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.slice(start, end).map(row => {
            const access = row.shareAtRiskAccepted ? true : false;

            return (
              <TableRow key={row.uid}>
                <TableCell>{row.uid.slice(0, 12)}</TableCell>
                <TableCell>{row.atRiskDate}</TableCell>
                <TableCell>{findCriteria(row.atRiskData)}</TableCell>
                {/* <TableCell>
                  <Button
                    disabled={access}
                    onPress={() =>
                      console.log('Sent help for student: ', row.uid)
                    }>
                    YES
                  </Button>
                </TableCell> */}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {/* <Link
        onClick={() => {
          if (!seeMore) {
            setEnd(page);
          } else {
            setStart(0);
            setEnd(short);
          }
          setSeeMore(!seeMore);
        }}
        style={{
          color: '#d68eb',
          fontSize: '15px',
          fontWeight: '500',
          letterSpacing: '0.3px',
          lineHeight: '24px',
          textDecoration: 'none',
          display: 'flex',
          alignSelf: 'flex-end',
          marginTop: '20px',
          cursor: 'pointer',
        }}>
        {seeMore ? 'See less' : 'See more'}
      </Link> */}
      {/* {seeMore && ( */}
      <>
        {end <= sorted.length && (
          <Link
            onClick={() => {
              setStart(start + page);
              setEnd(end + page);
            }}
            style={{
              color: '#d68eb',
              fontSize: '15px',
              fontWeight: '500',
              letterSpacing: '0.3px',
              lineHeight: '24px',
              textDecoration: 'none',
              display: 'flex',
              alignSelf: 'flex-end',
              marginTop: '20px',
              cursor: 'pointer',
            }}>
            Next
          </Link>
        )}
        {start && (
          <Link
            onClick={() => {
              setStart(start - page);
              setEnd(end - page);
            }}
            style={{
              color: '#d68eb',
              fontSize: '15px',
              fontWeight: '500',
              letterSpacing: '0.3px',
              lineHeight: '24px',
              textDecoration: 'none',
              display: 'flex',
              alignSelf: 'flex-end',
              marginTop: '20px',
              cursor: 'pointer',
            }}>
            Previous
          </Link>
        )}
      </>
    </DashboardTile>
  );
};

export default StudentList;
